export default __webpack_public_path__ + "static/media/teacherquestionblackboard.4c2a1d54.jpg";